module.exports = "/images/close-black-icon.svg?c0c727248a388fdfceb35f1c0d9f6ea4";